// import React from 'react';

// export default function coinpackages() {
//     return(
//         <div>
//             <h1>React coinpackages page</h1>
//         </div>
//     )
// }

import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SettingSidebar from "../components/Setttingsidebar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../App.css";
import { ApiUrl } from '../Constants/Weburl'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import CustomPagination from "../components/Custompagination";
import CustomContainer from '../components/Customsettingscontain';
import CustomTable from '../components/CustomTable';
import CustomButton from "../components/CustomButton";
import CustomInput from '../components/Custominput';
import { addCoinPackage, getCoinPurchases, deleteCoinPurchase , updateCoinPurchase} from "../services/reactapis";
import Layout from "../components/Layout";
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";
import DeleteModal from "../components/DeleteModal";

export default function Coinpackages() {

    const [allhashtag, setAllhashtag] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState("");
    const [inputValue, setInputValue] = useState(""); // For input field display

    //add hashtag state
    const [hashtags, setHashtags] = useState([]);
    const [newHashtag, setNewHashtag] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editingText, setEditingText] = useState("");

    //add modal 
    const [showModal, setShowModal] = useState(false);

    //save model
    const [showEditModal, setShowEditModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [editTag, setEditTag] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteCoins, setDeleteCoins] = useState(null);

    const [coinPackages, setCoinPackages] = useState([]);
    const [coins, setCoins] = useState('');
    const [inrAmount, setInrAmount] = useState('');
    const [usdAmount, setUsdAmount] = useState('');
    const [isActive, setIsActive] = useState(true);

    const navigate = useNavigate();
    const location = useLocation();

    const { toggleExpand, isExpanded } = useExpandableRows();

    const headers = [
        { label: "Coins", className: 'cp-col-coins' },
        { label: "Status", className: 'cp-col-status' },
        { label: "INR Amount", className: 'cp-col-inr', field: "inr" },
        { label: "USD Amount", className: 'cp-col-usd', field: "usd" },
        { label: "Action", className: 'cp-col-action rr-actions', field: "action" },
    ]


    const hiddenFields = useHiddenColumns(".rr1-table", headers);


    // Read search from URL on component mount
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get('search');
        if (searchParam) {
            console.log("Search term from URL:", searchParam);
            setSearchText(searchParam); // For API filtering
            //Do NOT set inputValue - keep it empty
        }
    }, []);

    // Update search when URL changes
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get('search');
        if (searchParam && searchParam !== searchText) {
            console.log("Search term updated from URL:", searchParam);
            setSearchText(searchParam);
            setCurrentPage(1);
            // ❌ Do NOT set inputValue - keep it empty
        }
    }, [location.search]);

    //all hashtag get api
    const fetchHashtags = async (page = 1) => {
        try {
            const res = await axios.get(`${ApiUrl}api/search`, {
                params: {
                    page,
                    limit: pageSize,
                    search: searchText
                }
            });

            console.log("hashtag search", res.data)

            setAllhashtag(res.data.data);
            setCurrentPage(page);
            setTotalPages(res.data.totalPages);

        } catch (e) {
            console.log("fetchHashtags error", e);
        }
    };

    useEffect(() => {
        fetchHashtags(1);
    }, [pageSize, searchText]);

    useEffect(() => {
        fetchCoinPackages();
    }, []);


    // Filter coin packages client-side based on searchText (from URL / search bar)
    const filteredCoinPackages = coinPackages.filter((item) => {
        if (!searchText) return true;
        const term = searchText.toLowerCase().trim();
        // dropdown click sends full label like "500 Coins" — pull out just the number too
        const numericTerm = term.match(/[\d.]+/)?.[0];

        return (
            String(item.coins).toLowerCase().includes(term) ||
            String(item.inrAmount).toLowerCase().includes(term) ||
            String(item.usdAmount).toLowerCase().includes(term) ||
            (item.isActive ? "active" : "inactive").includes(term) ||
            (numericTerm && (
                String(item.coins) === numericTerm ||
                String(item.inrAmount) === numericTerm ||
                String(item.usdAmount) === numericTerm
            ))
        );
    });


    const handleAddPackage = async () => {
        try {

            if (!coins || !inrAmount || !usdAmount) {
                alert("Please fill all fields");
                return;
            }

            const token = localStorage.getItem("adminToken");

            const data = {
                coins: Number(coins),
                inrAmount: Number(inrAmount),
                usdAmount: Number(usdAmount),
                isActive: isActive
            };

            console.log("ADDING PACKAGE:", data);

            const response = await addCoinPackage(token, data);

            if (response.success) {

                console.log("PACKAGE ADDED:", response);

                alert("Coin package added successfully");

                // Modal close
                setShowModal(false);

                // Clear form
                setCoins('');
                setInrAmount('');
                setUsdAmount('');
                setIsActive(true);

                // Refresh list
                fetchHashtags(1);
            }

        } catch (error) {

            console.log(
                "ADD PACKAGE FAILED:",
                error.response?.data || error.message
            );

            alert(
                error.response?.data?.message ||
                "Failed to add coin package"
            );
        }
    };

    const fetchCoinPackages = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminToken");

            const response = await getCoinPurchases(token);

            console.log("GET COIN PACKAGES:", response);

            if (response?.success) {
                setCoinPackages(response.data || []);
            }

        } catch (error) {
            console.error(
                "Get coin packages error:",
                error?.response?.data || error
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCoinPackages();
    }, []);

    // DELETE API
    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem("adminToken");

            const response = await deleteCoinPurchase(token, id);

            console.log("DELETE RESPONSE:", response);

            if (response?.success) {

                // UI-la immediately remove pannum
                setCoinPackages((prev) =>
                    prev.filter((item) => item.id !== id)
                );

                alert("Coin package deleted successfully");
            }

        } catch (error) {
            console.error(
                "Delete coin package error:",
                error?.response?.data || error
            );

            alert(
                error?.response?.data?.message ||
                "Failed to delete coin package"
            );
        }
    };


    const handleUpdate = async (id, updatedData) => {
    try {
        const token = localStorage.getItem("adminToken");

        const response = await updateCoinPurchase(token, id, updatedData);

        console.log("UPDATE RESPONSE:", response);

        if (response?.success) {

            setCoinPackages((prev) =>
                prev.map((item) =>
                    item.id === id ? response.data : item
                )
            );

   
            return true;
        }

        return false;

    } catch (error) {
        console.error(
            "Update coin package error:",
            error?.response?.data || error
        );

        alert(
            error?.response?.data?.message ||
            "Failed to update coin package"
        );

        return false;
    }
};


const handleUpdatePackage = async () => {
    if (!coins || !inrAmount || !usdAmount) {
        alert("Please fill all fields");
        return;
    }

    const ok = await handleUpdate(editId, {
        coins: Number(coins),
        inrAmount: Number(inrAmount),
        usdAmount: Number(usdAmount),
        isActive: isActive,
    });

    if (ok) {
        setShowModal(false);
        setEditId(null);
        setCoins('');
        setInrAmount('');
        setUsdAmount('');
        setIsActive(true);
    }
};

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setSearchText(value);
        setCurrentPage(1);

        const params = new URLSearchParams(location.search);
        if (value) {
            params.set('search', value);
        } else {
            params.delete('search');
        }
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const handleEditClick = (item) => {
        setEditId(item.id);
        setCoins(item.coins);
        setInrAmount(item.inrAmount);
        setUsdAmount(item.usdAmount);
        setIsActive(Boolean(item.isActive));
        setShowModal(true);
    };

    // const handleUpdatePackage = async () => {
    //     try {
    //         if (!coins || !inrAmount || !usdAmount) {
    //             alert("Please fill all fields");
    //             return;
    //         }

    //         const data = {
    //             coins: Number(coins),
    //             inrAmount: Number(inrAmount),
    //             usdAmount: Number(usdAmount),
    //             isActive: isActive,
    //         };

    //         // 👉 your update API call goes here (e.g. updateCoinPackage(editId, data, token))

    //         setShowModal(false);
    //         setEditId(null);
    //         setCoins('');
    //         setInrAmount('');
    //         setUsdAmount('');
    //         setIsActive(true);

    //         fetchCoinPackages();
    //     } catch (error) {
    //         console.log("UPDATE PACKAGE FAILED:", error.response?.data || error.message);
    //         alert(error.response?.data?.message || "Failed to update coin package");
    //     }
    // };

    return (
        <div className="layout">
            <Layout>

                <CustomContainer className="rr-wrapperhashtag" fluid="false">
                    {/* ── Header bar: [Coin Packages]  [Add Coins(center)]  [Show entries  Search] ── */}
                    <div className="ht-header-bar">
                        <h3 className="ht-page-title">Coin Packages</h3>

                        <CustomButton className="rr-add-btnhashtag ht-add-btn"
                            variant='#e2f0ef'
                            onClick={() => {
                                setEditId(null);
                                setCoins('');
                                setInrAmount('');
                                setUsdAmount('');
                                setIsActive(true);
                                setShowModal(true);
                            }}
                        >
                            Add Coins
                        </CustomButton>

                        <div className="ht-header-right">
                            <div className="rr-left">
                                Show
                                <select
                                    className="rr-select"
                                    value={pageSize}
                                    onChange={(e) => setPageSize(Number(e.target.value))}>
                                    <option>5</option>
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                </select>
                                entries
                            </div>
                            <div className="rr-right">
                                <span>Search:</span>
                                <CustomInput
                                    className="rr-search"
                                    type="text"
                                    value={inputValue}
                                    onChange={handleSearchChange}
                                    placeholder="Search packages"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rr-card">
                        <CustomTable
                            className="rr1-table coin-table"
                            headers={headers}
                        >
                            {filteredCoinPackages.length > 0 ? (
                                filteredCoinPackages.map((item) => (
                                    <React.Fragment key={item.id}>
                                        <tr className="rr-actionshastag">


                                            <td className="cp-col-coins">
                                                {hiddenFields.length > 0 && (
                                                    <button
                                                        type="button"
                                                        className={`row-expand-toggle ${isExpanded(item.id) ? "is-open" : ""}`}
                                                        onClick={() => toggleExpand(item.id)}
                                                        aria-label="Show more details"
                                                    >
                                                        {isExpanded(item.id) ? "−" : "+"}
                                                    </button>
                                                )}
                                                {item.coins}


                                            </td>
                                            <td className="cp-col-status">
                                                {item.isActive ? "Active" : "Inactive"}
                                            </td>
                                            <td className="cp-col-inr">₹{item.inrAmount}</td>
                                            <td className="cp-col-usd">${item.usdAmount}</td>
                                            <td className="cp-col-action rr-actions">
                                                <CustomButton
                                                    className="rr-icon-btn green"
                                                    // onClick={() => {
                                                    //     setEditId(item.id);
                                                    //     setEditTag(item.tag);
                                                    //     setShowEditModal(true);
                                                    // }}
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                </CustomButton>
                                                <CustomButton
                                                    className="rr-icon-btn red"
                                                    // onClick={() => handleDelete(item.id)}
                                                    onClick={() => {
                                                        setDeleteId(item.id);
                                                        setDeleteCoins(item.coins);
                                                        setShowDeleteModal(true);
                                                    }}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </CustomButton>
                                            </td>
                                        </tr>

                                        {isExpanded(item.id) && hiddenFields.length > 0 && (
                                            <tr className="row-expand-details">
                                                <td colSpan={5}>
                                                    <div className="expand-details">
                                                        {hiddenFields.map(({ field, label }) => (
                                                            <div className="expand-item" key={field}>
                                                                <span className="expand-label">{label}</span>

                                                                {field === "inr" && (
                                                                    <span className="expand-value">₹{item.inrAmount}</span>
                                                                )}

                                                                {field === "usd" && (
                                                                    <span className="expand-value">${item.usdAmount}</span>
                                                                )}

                                                                {field === "action" && (
                                                                    <div style={{ display: "flex", gap: 8 }}>
                                                                        <CustomButton
                                                                            className="rr-icon-btn green"
                                                                            // onClick={() => {
                                                                            //     setEditId(item.id);
                                                                            //     setEditTag(item.tag);
                                                                            //     setShowEditModal(true);
                                                                            // }}
                                                                            onClick={() => handleEditClick(item)}

                                                                        >
                                                                            <i className="bi bi-pencil"></i>
                                                                        </CustomButton>
                                                                        <CustomButton className="rr-icon-btn red" onClick={() => handleDelete(item.id)}>
                                                                            <i className="bi bi-trash"></i>
                                                                        </CustomButton>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5">No coin packages found</td>
                                </tr>
                            )}
                        </CustomTable>

                        <div className="rr-footer">
                            <span>
                                Showing 1 to {filteredCoinPackages.length} of {filteredCoinPackages.length} entries
                            </span>
                            <CustomPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={(page) => fetchHashtags(page)}
                                className="rr-pagination"
                                pageClassName="rr-page"
                                activeClassName="active"
                                ellipsisClassName="rr-page"
                            />
                        </div>
                    </div>
                </CustomContainer>
            </Layout>




            {/* Add Coin Package Modal */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                className="hashtag-add-modal"
            >
                <Modal.Header className="hashtag-modal-header">
                    <Modal.Title>{editId ? "Edit Coin Package" : "Add Coin Package"}</Modal.Title>
                    <CustomButton
                        type="button"
                        className="hashtag-close-btn"
                        // onClick={() => setShowModal(false)}
                        onClick={() => {
                            setShowModal(false);
                            setEditId(null);
                            setCoins('');
                            setInrAmount('');
                            setUsdAmount('');
                            setIsActive(true);
                        }}
                    >
                        ×
                    </CustomButton>
                </Modal.Header>


                <Modal.Body className="hashtag-modal-body">

                    {/* Coins */}
                    <Form.Group>
                        <Form.Label className="profile-pill">Coins</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Coins"
                            value={coins}
                            onChange={(e) => setCoins(e.target.value)}
                        />
                    </Form.Group>

                    {/* Active */}
                    <Form.Group className="mb-3">
                        <Form.Label className="profile-pill">Status</Form.Label>

                        <Form.Select
                            value={isActive ? "true" : "false"}
                            onChange={(e) =>
                                setIsActive(e.target.value === "true")
                            }
                        >
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </Form.Select>
                    </Form.Group>

                    {/* INR */}
                    <Form.Group>
                        <Form.Label className="profile-pill">INR Amount</Form.Label>
                        <Form.Control
                            type="number"
                            step="0.01"
                            placeholder="Enter INR Amount"
                            value={inrAmount}
                            onChange={(e) => setInrAmount(e.target.value)}
                        />
                    </Form.Group>

                    {/* USD */}
                    <Form.Group>
                        <Form.Label className="profile-pill">USD Amount</Form.Label>
                        <Form.Control
                            type="number"
                            step="0.01"
                            placeholder="Enter USD Amount"
                            value={usdAmount}
                            onChange={(e) => setUsdAmount(e.target.value)}
                        />
                    </Form.Group>

                </Modal.Body>

                <Modal.Footer className="hashtag-modal-footer">
                    <CustomButton
                        className="hashtag-close-footer-btn"
                        variant="secondary"
                        // onClick={() => setShowModal(false)}
                        onClick={() => {
                            setShowModal(false);
                            setEditId(null);
                            setCoins('');
                            setInrAmount('');
                            setUsdAmount('');
                            setIsActive(true);
                        }}
                    >
                        Cancel
                    </CustomButton>

                    <CustomButton
                        className="hashtag-save-btn"
                        variant="primary"
                        onClick={editId ? handleUpdatePackage : handleAddPackage}

                    >
                        {editId ? "Update" : "Add"}
                    </CustomButton>
                </Modal.Footer>
            </Modal>

            <DeleteModal
                show={showDeleteModal}
                close={() => {
                    setShowDeleteModal(false);
                    setDeleteId(null);
                    setDeleteCoins(null);
                }}
                onDelete={() => {
                    handleDelete(deleteId);
                    setShowDeleteModal(false);
                    setDeleteId(null);
                    setDeleteCoins(null);
                }}
                title="Delete Coin Package"
                message="Are you sure you want to delete this coin package?"
                itemName={deleteCoins ? `${deleteCoins} Coins` : ""}
            />
        </div>
    );
}
